import RoomSummary from './RoomSummary.vue';
export default RoomSummary;
